import React from "react";

export default function GlassCard({ children , maxWidth = "360px", paddingside = "32px",paddingTopBottom = "48px"}) {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: maxWidth,
        background: "rgba(255, 255, 255, 0.03)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.06)",
        borderRadius: "24px",
        padding: `${paddingTopBottom} ${paddingside}`,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.02)",
      }}
    >
      {children}
    </div>
  );
}
